import { TFunction } from 'i18next'

import { formatPrice } from '@shared/uttils'

type UseProductUnitProps = {
  isWeightProduct: boolean;
  value: number;
  price: number;
  t: TFunction;
};

type ProductUnitResult = {
  value: number;
  unit: string;
  total: string;
};

export default function useProductUnit ({
  isWeightProduct,
  value,
  price,
  t,
}: UseProductUnitProps): ProductUnitResult {
  if (isWeightProduct) {
    if (value < 1000) {
      return {
        value,
        unit: t('weight.gr'),
        total: formatPrice((value / 1000) * price),
      }
    }
    else {
      const kg = value / 1000
      return {
        value: kg,
        unit: t('weight.kg'),
        total: formatPrice(kg * price),
      }
    }
  }

  return {
    value,
    unit: t('weight.pc'),
    total: formatPrice(value * price),
  }
}
